var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-form-layout',{attrs:{"title":`${_vm.$t('selectors.select')} ${_vm.$tc('product.part', 1)} ${_vm.$t(
      'common.from'
    )} ${_vm.$t('inventory.name')}`,"size":"large"},on:{"submit":_vm.onSubmit}},[_c('v-form',{ref:"form"},[_c('ItemUnitsOnOrderEditForm')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }